var AboutPage = {
	"init" : function(){   	
   		var layers = [
     		$('[data-layer="1"]'),
          	$('[data-layer="2"]')
    	];
      
      	var speeds = [
        	4,
          	8
        ];
      
      	var layerCount = layers.length;
      
      	for(var i = 0; i < layerCount; i++){
        	for(var a = 0; a < layers[i].length; a++){
              layers[i][a] = $(layers[i][a]);
            }
        }
      	
      	var scrollTop = $(window).scrollTop();
      
      	$(window).scroll(function(){
        	scrollTop = $(window).scrollTop();
        });
      	
      	var headerHeight = 0;
      
      	var setInitConfig = function(){
          var windowHeight = window.innerHeight;
          
        	for(var i = 0; i < layerCount; i++){
              for(var a = 0; a < layers[i].length; a++){
              	var elem = layers[i][a];
                elem.data("offset",(elem.offset().top - windowHeight + headerHeight));
                elem.data("top-offset-pct",elem.height() * Number(elem.attr("data-top-offset-pct")) / 100);
              }
          	}
      	}
        
        var setMobileWow = function(){
          var elems = $('[data-wow-mobile]');
          for(var i = 0; i < elems.length; i++){
              	var elem = $(elems[i]);
                if(elem.attr("data-wow-mobile") != undefined){
                  elem.removeClass("bounceInUp fadeInRight fadeInLeft fadeIn");
                  elem.addClass("wow");
                  elem.addClass(elem.attr("data-wow-mobile"));
                }
            	if(elem.attr("data-wow-mobile-offset") != undefined){
                  elem.attr("data-wow-offset", elem.attr("data-wow-mobile-offset"));
                }
            	if(elem.attr("data-wow-mobile-delay") != undefined){
                  elem.attr("data-wow-delay", elem.attr("data-wow-mobile-delay"));
                }
          	}
        }
        
        if(!device.mobile()){
        	setInitConfig();
      		setTimeout(setInitConfig,500);
      		$(window).on("resize",setInitConfig);
        }else{
          setMobileWow();
        }
       
      	
      	var lastScrollTop = -1;
      	
      	var step = function(){
          	if(lastScrollTop != scrollTop){
            	for(var i = 0; i < layerCount; i++){
                  var speed = speeds[i];
                  for(var a = 0; a < layers[i].length; a++){
                      var elem = layers[i][a];
                      var position = Math.min(0,-(scrollTop - elem.data("offset")) / speed) + elem.data("top-offset-pct");
                      elem.css({
                          'transform': "translate3d(0, " + position + "px,0)"
                      });
                  }
              	}
              	lastScrollTop = scrollTop;
          	}        	
          	window.requestAnimationFrame(step);
        }
      
      	if(!device.mobile()) window.requestAnimationFrame(step);
      
      	new WOW().init();
	}
}

AboutPage.init();
//jQuery(document).ready(AboutPage.init.bind(Site));